<template>
  
  <div class="login_container">
    <!-- 登录表单区域 -->
    <el-row style="margin:0 20px">
  
  <el-col :span="24">
    
    <el-form :model="loginForm" :rules="rules" ref="loginFromRef">
      <!-- 头像区域 -->
      <!-- <div class="login-logo"> -->
        <!-- <img src="../../assets/logo.png" alt="" /> -->
      <!-- </div> -->
      <div class="title">
        <img src="../../assets/logo.png" alt="" />
        <h1>开发者端</h1>
      </div>
      
      <div class="form-content">
        <!-- 用户名 -->
        <el-form-item prop="email" class="userfram">
          <el-input prefix-icon="iconfont icon-youjian" v-model="loginForm.email" @input="changeInput($event)"></el-input>
        </el-form-item>
        <!-- 密码 -->
        <el-form-item prop="password">
          <el-input
            prefix-icon="iconfont icon-mima"
            v-model="loginForm.password"
            type="password"
            @input="changeInput($event)"></el-input>
        </el-form-item>
        <!-- 验证码 -->
        <el-row>
          <el-col :span="24">
            <el-form-item prop="code" class="codefram">
              <el-input prefix-icon="iconfont icon-mima3" v-model="loginForm.code" class="left" @input="changeInput($event)"></el-input>
              <div class="code">
                <!-- <img :src="imgSrc" alt="" @click="getCode"/> -->
                <div v-html='code' @click="getCode"></div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 忘记密码 和 注册账号 -->
        <el-row>
          <el-col :span="24">
            <div class="info">
              <router-link to="/forget">忘记密码</router-link>
              <router-link to="/register">注册账号</router-link>
            </div>
         </el-col>
        </el-row>
        <!-- 按钮区域 -->
        <el-form-item>
          <el-button type="primary" @click="login">登录</el-button>
          <!-- <el-button type="info" @click="reset">重置</el-button> -->
        </el-form-item>
      </div>
    </el-form>
    </el-col>
  </el-row>
  </div>
  
</template>

<script>
export default {
  data() {
    return {
      loginForm: {
        email: "",
        password: "",
        code: "",
        sign:""
      },
      code:"",
      rules: {
        email: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          {
            min: 5,
            max: 40,
            message: "长度在 5 到 40 个字符",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 5,
            max: 16,
            message: "长度在 5 到 16 个字符",
            trigger: "blur",
          },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
    };
  },
  created(){
    this.getCode()
    this.goHome()
    // if(window.sessionStorage.getItem('token')){
    //   this.$router.push('welcome')
    // }
  },
  methods: {
    // reset() {
    //   /**
    //    * 需要表单重置
    //    * 并且需要移除校验结果
    //    */
    //   // this.loginForm.email = "";
    //   // this.loginForm.password = "";
    //   this.$refs.loginFromRef.resetFields();
    // },
    async goHome(){
      // console.log("检测免登录");
      const token = window.localStorage.getItem('token')
      // console.log("localStorage：token:",token);
      if (token) {
        window.sessionStorage.setItem("token", token);
        console.log("发送请求1111111111");
        const res = await this.$http.post("/account/info");
        console.log("-----------免登录res:",res);
        if (res.data.meta.status === -3 && res.data.meta.msg == "无效的token.") {
          window.localStorage.setItem('token', '');
          window.sessionStorage.clear();
          this.$router.push('/login')
          return this.$notify.error({title: '错误401', message: "无效的token"});
        }else if(res.data.meta.status === -5){
          window.localStorage.setItem('token', '');
          window.sessionStorage.clear();
          this.$router.push('/login')
          return this.$notify.error({title: '错误401', message: "登录状态已失效"});
        }else if(res.data.meta.status === -6){
          console.log("去充值页面");
          window.sessionStorage.setItem('email',res.data.data.email)
          window.sessionStorage.setItem('shareId',res.data.data.shareId)
          this.$router.push('/recharge')
          alert('套餐已过期，请充值\n充值成功后，请在页面右上角账号处进行退出登录\n重新登录即可\n如有问题请加管理QQ：58346871')
        }else if(res.data.meta.status === -7){
          console.log("进入主页");
          this.$router.push("/welcome");
          window.sessionStorage.setItem('email',res.data.data.email)
          window.sessionStorage.setItem('shareId',res.data.data.shareId)
          alert('套餐即将到期(还剩'+res.data.meta.msg+')，\n如有问题请加管理QQ：58346871')
        }else{
          console.log("进入主页");
          this.$router.push("/welcome");
          window.sessionStorage.setItem('email',res.data.data.email)
          window.sessionStorage.setItem('shareId',res.data.data.shareId)
        }
      }
    },
    login() {
      this.$refs.loginFromRef.validate(async (value) => {
        if (!value) {
          return this.$message.error("账号有问题");
        } else {
          const res = await this.$http.post("login", this.loginForm);
          if (res.data.meta.status !== 200) {
            this.getCode()
            return this.$message.error(res.data.meta.msg);
          } else {
            /**
             * 登陆成功 1.需要将token保存本地 sessionStorage
             *         2.通过编程式导航跳转到后台主页
             * sessionStorage 会话结束就会清空.所以很适合保存token
             */
            window.sessionStorage.setItem("token", res.data.data.token);
            window.sessionStorage.setItem('email',res.data.data.result.email)
            window.sessionStorage.setItem('shareId',res.data.data.result.shareId)
            window.sessionStorage.setItem('role','developer')
            window.localStorage.setItem('token', res.data.data.token)
            //把数据传到vuex
            this.$store.commit('getShareMsg',res.data.data.result.shareId)
            this.$store.commit('getAccount',res.data.data.result.email)
            this.$router.push("/welcome");
            return this.$message.success("登陆成功");
          }
        }
      });
    },
    async getCode(){
      //this.imgSrc = this.imgSrc+Date.parse(new Date())
      let result = await this.$http.get('getcode?' + Date.parse(new Date()))
      this.code = result.data.img
      this.loginForm.sign = result.data.sign
      //console.log('this.loginForm.sign',this.loginForm.sign);
      //console.log('result.data',result.data);
    },
    changeInput(e){
      this.$forceUpdate()
    }
  },
};
</script>

<style lang="less" scoped>
.login_container {
  background-color: #2b4b6b;
  height: 100%;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items:center;/*垂直居中*/
  a {
    text-decoration: none;
    color: #409eff;
    font-size: 15px;
  }
  .login-logo {
    height: 130px;
    width: 130px;
    border-radius: 50%;
    border: 1px solid #eee;
    overflow: hidden;
    position: absolute;
    left: 50%;
    transform: translate(-50%, -80%);
    z-index: 1;
    img {
      height: 100%;
      width: 100%;
      background-color: #eee;
    }
  }

  .el-form {
    height: 390px;
    background-color: #fff;
    border-top: 1px solid;
    border-radius: 5px;
    padding: 0 20px;
    .form-content {
      // margin-top: 80px;
      .info {
        margin-top: -4px;
        display: flex;
        justify-content: space-between;
      }
      .userfram{
        // margin-top: 80px;
      }
    }
    .el-form-item {
      margin-top: 30px;
      .left,
      .code {
        float: left;
        // width: 135px;
        width: 45%;
        height: 40px;
        img {
          // border: 1px solid #eee;
          width: 100%;
          height: 100%;
          // margin-left: 55px;
        }
        div {
          width: 100%;
          height: 100%;
          text-align: center;
          vertical-align: -9px;
          
        }
      }
      .el-button {
        float: right;
        margin-left: 20px;
        width: 100%;
        margin-top: -15px;
      }
    }
    .codefram{
      margin-top: 8px;
    }
  }
  h2{
    margin-top: 25px;
    margin-bottom: 0;
    text-align: center;
  }
}

.title{
  margin-top: 10px;
  text-align: center;
  img {
    width: 50px;
    height: 50px;
    vertical-align: -13px;
  }
  h1{
    display: inline;
    margin-left: 20px;
  }
}
  


</style>